import { __decorate } from "tslib";
import { injectable } from "inversify";
let TranslationCache = class TranslationCache {
};
TranslationCache = __decorate([
    injectable()
], TranslationCache);
export { TranslationCache };
let DefaultTranslationCache = class DefaultTranslationCache extends TranslationCache {
    constructor() {
        super(...arguments);
        this.inMemoryCache = new Map();
    }
    get(locale) {
        return this.inMemoryCache.get(locale.localeCode);
    }
    set(locale, translations) {
        this.inMemoryCache.set(locale.localeCode, translations);
    }
};
DefaultTranslationCache = __decorate([
    injectable()
], DefaultTranslationCache);
export { DefaultTranslationCache };
//# sourceMappingURL=TranslationCache.js.map